import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const VoorraadOverzicht = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [bussen, setBussen] = useState([]);
  const [busSel, setBusSel] = useState(null);
  const [busRows, setBusRows] = useState([]);
  const [catalogus, setCatalogus] = useState([]);
  const [zoek, setZoek] = useState('');

  const load = async () => {
    const [d, b, c] = await Promise.all([api.get('/bussen/dashboard'), api.get('/bussen'), api.get('/materialen')]);
    setData(d.data); setBussen(b.data.bussen || []); setCatalogus(c.data.materialen || []);
  };
  useEffect(() => { load().catch(() => {}); }, []);
  const loadBus = async (id) => { setBusSel(id); const r = await api.get(`/bussen/${id}/voorraad`); setBusRows(r.data.voorraad || []); };
  const zetStandaard = async (materiaalId, standaard, aantal) => {
    await api.put(`/bussen/${busSel}/voorraad/${materiaalId}`, { standaard_aantal: standaard, aantal });
    await loadBus(busSel); load().catch(() => {});
  };
  const fmt = d => d ? new Date(d).toLocaleString('nl-NL', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '-';
  const card = { background: 'white', borderRadius: 12, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,.08)', marginBottom: 16 };
  const th = { textAlign: 'left', fontSize: 12, color: '#64748b', padding: '6px 8px', borderBottom: '1px solid #e5e7eb' };
  const td = { padding: '8px', borderBottom: '1px solid #f1f5f9', fontSize: 14 };

  if (!data) return <div style={{ padding: 40, textAlign: 'center' }}>⏳ Laden...</div>;
  return (
    <div>
      <div className="dashboard-header"><h1>📦 Voorraad</h1></div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div style={card}>
          <h3 style={{ margin: '0 0 10px' }}>🔴 Onder minimum ({data.onder_minimum.length})</h3>
          {data.onder_minimum.length === 0 ? <div style={{ color: '#94a3b8' }}>Alles op peil</div> : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr><th style={th}>Artikel</th><th style={th}>Voorraad</th><th style={th}>Min</th><th style={th}>Locatie</th><th style={th}>Bestelling</th></tr></thead>
              <tbody>{data.onder_minimum.map(m => (
                <tr key={m.id}><td style={td}><b>{m.naam}</b> <code style={{ fontSize: 11, color: '#64748b' }}>{m.code}</code></td><td style={{ ...td, color: '#dc2626', fontWeight: 700 }}>{Number(m.voorraad)}</td><td style={td}>{Number(m.min_voorraad)}</td><td style={td}>{m.voorraad_locatie || '-'}</td>
                <td style={td}>{m.open_bestelling ? <span style={{ color: '#059669' }}>✓ open</span> : <button className="btn-secondary" style={{ fontSize: 12, padding: '3px 8px' }} onClick={() => navigate('/bestellen')}>bestellen →</button>}</td></tr>
              ))}</tbody>
            </table>
          )}
        </div>
        <div style={card}>
          <h3 style={{ margin: '0 0 10px' }}>🚐 Bus-tekorten ({data.bus_tekorten.length})</h3>
          {data.bus_tekorten.length === 0 ? <div style={{ color: '#94a3b8' }}>Alle bussen compleet</div> : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr><th style={th}>Bus</th><th style={th}>Artikel</th><th style={th}>In bus</th><th style={th}>Standaard</th><th style={th}>Magazijn</th></tr></thead>
              <tbody>{data.bus_tekorten.map((r, i) => (
                <tr key={i}><td style={td}><b>{r.bus}</b></td><td style={td}>{r.naam}</td><td style={{ ...td, color: '#b45309', fontWeight: 700 }}>{Number(r.aantal)}</td><td style={td}>{Number(r.standaard_aantal)}</td><td style={{ ...td, color: Number(r.magazijn) < Number(r.tekort) ? '#dc2626' : 'inherit' }}>{Number(r.magazijn)}</td></tr>
              ))}</tbody>
            </table>
          )}
        </div>
      </div>

      <div style={card}>
        <h3 style={{ margin: '0 0 10px' }}>🚐 Bussen — standaardinhoud instellen</h3>
        <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
          {bussen.map(b => <button key={b.id} onClick={() => loadBus(b.id)} className="btn-secondary" style={{ background: busSel === b.id ? '#00D4AA' : 'white', color: busSel === b.id ? '#0a0e1a' : '#374151', fontWeight: 600 }}>{b.code} <span style={{ fontSize: 11, color: busSel === b.id ? '#0a0e1a' : '#94a3b8' }}>({Number(b.in_bus)} in bus{Number(b.artikelen_tekort) > 0 ? ` · ${b.artikelen_tekort} tekort` : ''})</span></button>)}
          <button className="btn-secondary" onClick={async () => { const code = window.prompt('Bus-code (bijv. T04):'); if (!code) return; await api.post('/bussen', { code }); load(); }}>+ Bus</button>
        </div>
        {busSel && (
          <>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 12 }}>
              <thead><tr><th style={th}>Artikel</th><th style={th}>In bus</th><th style={th}>Standaard</th><th style={th}>Magazijn</th><th style={th}></th></tr></thead>
              <tbody>{busRows.map(r => (
                <tr key={r.materiaal_id}>
                  <td style={td}><b>{r.naam}</b> <span style={{ color: '#94a3b8', fontSize: 12 }}>{r.eenheid}</span></td>
                  <td style={td}><input type="number" step="1" defaultValue={Number(r.aantal)} onBlur={e => zetStandaard(r.materiaal_id, undefined, e.target.value)} style={{ width: 70, padding: 4 }} /></td>
                  <td style={td}><input type="number" step="1" defaultValue={Number(r.standaard_aantal)} onBlur={e => zetStandaard(r.materiaal_id, e.target.value, undefined)} style={{ width: 70, padding: 4 }} /></td>
                  <td style={td}>{Number(r.magazijn)}</td>
                  <td style={td}><button className="btn-secondary" style={{ color: 'red', fontSize: 12 }} onClick={async () => { if (window.confirm('Uit buslijst halen?')) { await api.delete(`/bussen/${busSel}/voorraad/${r.materiaal_id}`); loadBus(busSel); } }}>✕</button></td>
                </tr>
              ))}</tbody>
            </table>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <input value={zoek} onChange={e => setZoek(e.target.value)} placeholder="Artikel toevoegen aan bus… (zoek)" style={{ flex: 1, padding: 8, border: '1px solid #d1d5db', borderRadius: 6 }} />
            </div>
            {zoek.length >= 2 && (
              <div style={{ border: '1px solid #e5e7eb', borderRadius: 6, maxHeight: 180, overflowY: 'auto', marginTop: 4 }}>
                {catalogus.filter(m => !busRows.some(r => r.materiaal_id === m.id) && ((m.naam || '').toLowerCase().includes(zoek.toLowerCase()) || (m.code || '').toLowerCase().includes(zoek.toLowerCase()))).slice(0, 15).map(m => (
                  <div key={m.id} onClick={async () => { const st = window.prompt(`Standaard aantal ${m.naam} in bus:`, '1'); if (st === null) return; await zetStandaard(m.id, st, st); setZoek(''); }} style={{ padding: '6px 10px', cursor: 'pointer', fontSize: 13, borderBottom: '1px solid #f1f5f9' }}><code style={{ fontSize: 11, color: '#64748b' }}>{m.code || '—'}</code> {m.naam}</div>
                ))}
              </div>
            )}
          </>
        )}
      </div>

      <div style={card}>
        <h3 style={{ margin: '0 0 10px' }}>📋 Gebruik uit voorraad/bus — laatste 30 dagen ({data.gebruik.length})</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr><th style={th}>Wanneer</th><th style={th}>Ref</th><th style={th}>Artikel</th><th style={th}>Aantal</th><th style={th}>Bron</th><th style={th}>Monteur</th><th style={th}>Werkorder / object</th></tr></thead>
          <tbody>{data.gebruik.map(g => (
            <tr key={g.id}><td style={td}>{fmt(g.verzonden_op)}</td><td style={td}><code style={{ fontSize: 11 }}>{g.referentie}</code></td><td style={td}>{g.materiaal_naam}</td><td style={td}>{Number(g.aantal)} {g.eenheid}</td><td style={td}>{g.bus ? `🚐 ${g.bus}` : '🏭 magazijn'}</td><td style={td}>{g.monteur || '-'}</td>
            <td style={td}>{g.werkorder_id ? <span style={{ cursor: 'pointer', color: '#2563eb' }} onClick={() => navigate(`/werkorder/${g.werkorder_id}`)}>W{String(g.werkorder_id).padStart(4, '0')}</span> : null}{g.werkorder_id && g.object_naam ? ' · ' : ''}{g.object_naam || (!g.werkorder_id ? '-' : '')}</td></tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
};
export default VoorraadOverzicht;
